function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M21.103 9h-18V7l9-4 9 4v2z",
  stroke: "currentColor",
  strokeWidth: 1.51,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.603 15.5v-4M19.602 11.5v4M9.603 11.5v4M14.602 11.5v4",
  stroke: "currentColor",
  strokeWidth: 1.51,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M3.103 18h18v3h-18v-3z",
  stroke: "currentColor",
  strokeWidth: 1.51,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgBank;